import { infer as Infer, z } from 'zod';

export const passwordChangeSchema = z
  .object({
    password: z.string('Hasło jest wymagane').trim().min(8, 'Hasło musi mieć co najmniej 8 znaków'),
    confirmPassword: z.string('Potwierdzenie hasła jest wymagane').trim().min(8, 'Potwierdzenie hasła musi mieć co najmniej 8 znaków'),
    authToken: z.string().nullable().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Hasła muszą być identyczne',
    path: ['confirmPassword'],
  });

export type PasswordChangeSchema = Infer<typeof passwordChangeSchema>;
